import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getXhtmlVerifactu (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      const data = mock.getNotifications

      resolve(data)
    })
  } else {
    const req = {
      url: '/api/verifactu/getxhtmlVerifactu',
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getXhtmlVerifactu }
